/* TinyTAN 送料無料バー — カート更新に追従（Dawnのpubsubに乗る） */
(function () {
  var bar = document.querySelector('[data-tt-shipbar]');
  if (!bar) return;
  var threshold = parseInt(bar.dataset.threshold, 10) || 0;
  var msg = bar.querySelector('[data-tt-shipbar-msg]');
  var fill = bar.querySelector('[data-tt-shipbar-fill]');
  if (!threshold || !msg) return;

  function yen(cents) { return '¥' + Math.round(cents / 100).toLocaleString('ja-JP'); }
  function render(total) {
    if (fill) fill.style.width = Math.min(total / threshold * 100, 100) + '%';
    if (total >= threshold) { msg.textContent = '送料無料でお届けします'; }
    else { msg.innerHTML = 'あと <b>' + yen(threshold - total) + '</b> で送料無料'; }
  }
  function refresh() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { render(c.total_price); })
      .catch(function () {});
  }

  if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (ev) {
      if (ev && ev.cartData && typeof ev.cartData.total_price === 'number') { render(ev.cartData.total_price); }
      else { refresh(); }
    });
  }
})();
